import { IWidgetDirectiveType } from '../IWidgetDirectiveType';
import {
  IPdfVisibilityDirective,
  PdfVisibilityDirectiveSchema,
} from './IPdfVisibilityDirective';
import { PdfVisibilityDirectiveConfigComponent } from './PdfVisibilityDirectiveConfigComponent';

export const PDF_VISIBILITY_META_KEY = 'pdf-visibility';

/**
 * Direttiva per l'esportazione dei metadati di un campo in forma
 * normalizzata.
 */
export const PdfVisibilityDirectiveType: IWidgetDirectiveType<IPdfVisibilityDirective> =
  {
    name: 'pdfVisibility',
    key: 'pdfVisibility',
    allowsWidget: () => true,
    configComponent: PdfVisibilityDirectiveConfigComponent,
    configSchema: PdfVisibilityDirectiveSchema,
    formSchemaModifier: ({ directiveConfig, schema }) => {
      return schema.meta({
        [PDF_VISIBILITY_META_KEY]: directiveConfig.visibility,
      });
    },
  };
